/**
 * Route-level error boundary — the react-router equivalent of Next's
 * `app/error.tsx`.
 *
 * Mounted as `errorElement` on the root route, so a throw anywhere in the tree
 * renders this instead of a blank page. "Try again" reloads rather than
 * re-rendering the segment: react-router has no `reset()`, and the state that
 * produced the throw is usually the state we want to discard.
 */
import { logger } from "@swarm/shared/logger";
import { useEffect } from "react";
import { useRouteError } from "react-router-dom";

export function ErrorBoundary() {
  const error = useRouteError();

  useEffect(() => {
    logger.error(
      { err: error instanceof Error ? { message: error.message, stack: error.stack } : error },
      "unhandled render error",
    );
  }, [error]);

  return (
    <div className="flex flex-col items-center justify-center gap-4 p-8" id="route-error">
      <h2 id="route-error-title">Something went wrong!</h2>
      <button id="route-error-retry" type="button" onClick={() => window.location.reload()}>
        Try again
      </button>
    </div>
  );
}
